import {GetCountiesResponse, GetVoivodeshipResponse} from "API/Region/Region.Models";

export const prepareVoivodeships = (voivodeships: GetVoivodeshipResponse) => (voivodeships ?? [])
  .map(({province, description}) => ({value: province, label: description}))
export const prepareCounties = (counties: GetCountiesResponse['counties']) => (counties ?? [])
  .map(({id, name}) => ({value: id, label: name}))



// WEBPACK FOOTER //
// ./src/components/Layout/Form/AddUserForm.Services.ts